<template>
  <div class="card-brutal-static p-6 h-full">
    <div class="flex items-center justify-between gap-4 mb-4">
      <span class="badge-brutal" :class="badgeClass">
        {{ category }}
      </span>
    </div>

    <h3 class="text-xl font-bold mb-3">{{ title }}</h3>
    <p class="text-text-secondary leading-relaxed">{{ description }}</p>
    <p
      v-if="result"
      class="mt-4 pt-3 border-t-2 border-border font-mono text-sm font-bold"
    >
      {{ result }}
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  category: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  result: {
    type: String,
    default: '',
  },
  variant: {
    type: String,
    default: 'primary',
    validator: (value) => ['primary', 'accent', 'pink', 'lavender'].includes(value),
  },
});

const badgeClass = computed(() => {
  const map = {
    primary: 'bg-primary-light',
    accent: 'bg-accent',
    pink: 'bg-brutal-pink/30',
    lavender: 'bg-brutal-lavender/40',
  };
  return map[props.variant];
});
</script>
